import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeSubstancePreviousEvCode } from "../Entity/TreeNodeSubstancePreviousEvCode";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsSubstancePreviousEvCode extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;    
    constructor(injector: Injector, parent:any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Previous EV Codes (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Previous EV Codes'
        this.items = items;

        if (this.cloningNode){
            return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeSubstancePreviousEvCode(injector,false, item,this));
        }
    }

    override getHeaders(): string[] {
        return ['Previous EV Code'];
    }

   override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsSubstancePreviousEvCode = new TreeNodeMedicinalProductsSubstancePreviousEvCode(this.ioc!,newParent, true, this.items);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }
}